package com.dotdrives.repository

import com.dotdrives.client.PublicGivingClient
import com.dotdrives.model.*

interface PublicGivingRepository {
    suspend fun form(orgId: String, slug: String): PublicGivingForm

    suspend fun checkout(request: PublicCheckoutRequest): PublicCheckoutResult

    suspend fun restartCheck(request: PublicCheckoutRequest): PublicRestartResult

    suspend fun status(orgId: String, operationId: String, token: String): PublicPaymentStatus
}

class SupabasePublicGivingRepository(
    private val client: PublicGivingClient = PublicGivingClient()
) : PublicGivingRepository {
    override suspend fun form(orgId: String, slug: String) = client.form(orgId, slug)

    override suspend fun checkout(request: PublicCheckoutRequest) = client.checkout(request)

    override suspend fun restartCheck(request: PublicCheckoutRequest) = client.restartCheck(request)

    override suspend fun status(orgId: String, operationId: String, token: String) =
        client.status(orgId, operationId, token)
}
